// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-module--loading--2_ax6","loadingBg":"loading-module--loadingBg--fkS9m","logo":"loading-module--logo--2Mg0l"};